import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "className", "defaultActiveKey", "items", "collapsible"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import classNames from 'classnames';
import { ListGroup, ListGroupItem, Accordion, Typography, Link } from '../../components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var SidebarNav = function SidebarNav(_ref) {
  var title = _ref.title,
      className = _ref.className,
      defaultActiveKey = _ref.defaultActiveKey,
      items = _ref.items,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? true : _ref$collapsible,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs("div", _objectSpread(_objectSpread({
    "data-testid": "side-nav-bar",
    className: className
  }, props), {}, {
    children: [/*#__PURE__*/_jsx(Typography, {
      type: "sub-heading-2",
      className: "ps-200 text-uppercase pt-200 mb-150",
      children: title
    }), /*#__PURE__*/_jsx(Accordion, {
      className: classNames('sidebar-nav', {
        'sidebar-nav--not-collapsible': !collapsible
      }),
      defaultActiveKey: defaultActiveKey,
      children: items.map(function (item) {
        var _item$options;

        if (item.href) {
          return /*#__PURE__*/_jsx(Link, {
            href: item.href,
            className: "accordion-item justify-content-between accordion-item-link accordion-button w-100 collapsed",
            icon: item.icon,
            fluid: true,
            children: item.title
          }, item.title);
        }

        return /*#__PURE__*/_jsxs(Accordion.Item, {
          eventKey: item.title,
          children: [/*#__PURE__*/_jsx(Accordion.Button, {
            as: Link,
            role: "button",
            onClick: item.onClick,
            children: item.title
          }), item.options && item.options.length > 0 && /*#__PURE__*/_jsx(Accordion.Body, {
            children: /*#__PURE__*/_jsx(ListGroup, {
              children: (_item$options = item.options) === null || _item$options === void 0 ? void 0 : _item$options.map(function (option) {
                return /*#__PURE__*/_jsx(ListGroupItem, {
                  children: /*#__PURE__*/_jsx(Link, {
                    className: classNames('accordion-item__option', option.active ? 'accordion-item__option--active' : ''),
                    href: option.href,
                    onClick: option.onClick,
                    children: option.title
                  })
                }, option.title);
              })
            })
          })]
        }, item.title);
      })
    })]
  }));
};

export default SidebarNav;